<template>
    <v-row>
        <v-col cols="12">
            <v-card
                outlined
            >
                <v-card-title>
                    <v-icon left>mdi-account</v-icon>
                    {{ $t('user.profile') }}

                    <v-spacer></v-spacer>

                    <UserFormDialog></UserFormDialog>
                </v-card-title>
                <v-card-text>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col md="9">
                            <v-simple-table>
                                <tr>
                                    <td>
                                        {{ $t('form.user.name.label')}}
                                    </td>
                                    <td>{{ user.firstname }} {{ user.name }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('form.user.company.label')}}</td>
                                    <td>{{ user.company }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('form.user.company_role.label')}}</td>
                                    <td>{{ user.company_role }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('user.since') }}</td>
                                    <td>{{ user.created_at|formatDate }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        {{ $t('form.user.email.label')}}
                                    </td>
                                    <td>{{ user.email }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('form.user.language.label')}}</td>
                                    <td>
                                        {{ $t('language.' + user.locale) }}
                                    </td>
                                </tr>
                            </v-simple-table>
                        </v-col>
                        <v-col md="3">
                            <v-img v-if="user.avatar" :src="user.avatar" />
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <v-card
                    outlined
            >
                <v-card-title>
                    <v-icon left>mdi-lock</v-icon>
                    {{ $t('user.security') }}
                </v-card-title>
                <v-card-text>
                    <v-divider></v-divider>
                    <br>
                    <UserPasswordFormDialog></UserPasswordFormDialog>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import UserPasswordFormDialog from '../../components/User/UserPasswordFormDialog'
    import UserFormDialog from '../../components/User/UserFormDialog'
    import { mapGetters } from 'vuex'

    export default {
      name: 'Profile',
      components: { UserPasswordFormDialog, UserFormDialog },
      computed: {
        ...mapGetters({
          user: 'user/userInfo'
        })
      },
    }
</script>
